export default __webpack_public_path__ + "static/media/app-banner.b1bf230c.png";